export default "__VITE_ASSET__n3pzM3fe__";